import React from 'react';

import { ZeosButton } from '../../components/Shared/ZeosButton';
import { AnonymousLayout } from '../AnonymousTemplate';

export const UapiCallbackScreen = () => {
  return (
    <AnonymousLayout
      title="Utility Authorization"
      message="We are securely processing your authorization.  We'll notify you by email when it's complete.  Please close this window to return to ZEOS."
      contentType="other"
      content={
        <div className="flex justify-center">
          <ZeosButton
            label="Close"
            onPress={() => window.close()}
            type="button"
            mode="action"
          />
        </div>
      }
    />
  );
};
